export type InviteEmailToken = {
  value: string;
  valid: boolean;
};

export type WorkspaceInviteRecipient = {
  email: string;
  manager: string;
  group: string[];
};

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidInviteEmail = (email: string) =>
  EMAIL_PATTERN.test(email.trim());

export const addInviteEmailTokens = (
  current: InviteEmailToken[],
  rawValue: string,
) => {
  const knownEmails = new Set(
    current.map((token) => token.value.toLowerCase()),
  );
  const nextTokens = rawValue
    .split(/[,;\n\s]+/)
    .map((value) => value.trim())
    .filter(Boolean)
    .filter((value) => {
      const normalized = value.toLowerCase();
      if (knownEmails.has(normalized)) return false;
      knownEmails.add(normalized);
      return true;
    })
    .map((value) => ({value, valid: isValidInviteEmail(value)}));

  return [...current, ...nextTokens];
};

export const buildWorkspaceInvitePayload = (
  emails: InviteEmailToken[],
  manager: string,
  groups: string[],
): {emails: WorkspaceInviteRecipient[]} => ({
  emails: emails.map(({value}) => ({
    email: value,
    manager,
    group: groups,
  })),
});
